export class KeyValuePair {

    key: string;
    value: any;

    constructor(_key: string, _value: any) {
        this.key = _key;
        this.value = _value;
    }
}


// WEBPACK FOOTER //
// ./src/app/modules/common/entity/key-value-pair.ts